module.exports = __webpack_public_path__ + "img/report-problem2.d680bfed.svg";